import React from "react";
import { Link } from "react-router-dom";

var pic1 = require('../../assets/images/blog/blog-small/pic1.jpg');
var pic2 = require('../../assets/images/blog/blog-small/pic2.jpg');
var pic3 = require('../../assets/images/blog/blog-small/pic3.jpg');
//var blogBig = require('../../assets/images/blog/blog-big.jpg');

 const blogs = [
        { id: 1, title: 'Republic Day Celebrations', imageThumbnail: pic1,imageLarge: pic1, createdDate: new Date(), createdBy:'Rakesh Singh', comments:3, description:'Republic Day celebration in school is a special event where students and teachers come together to celebrate an important day.'},
		{ id: 2, title: 'Rakhi Making Activity', imageThumbnail: pic2,imageLarge: pic2, createdDate: new Date(), createdBy:'Ram Sharma', comments:3, description:'Students can participate in crafting their own Rakhis using colorful threads, beads, and other decorative materials.'},
		{ id: 3, title: 'Meet the Teacher', imageThumbnail: pic3,imageLarge: pic3, createdDate: new Date(), createdBy:'Vikash Sir', comments:3, description:'A classic and fan favorite! In the cafeteria or auditorium, each grade level sets up a table to meet and greet their upcoming students and families.'},
      ];
	  
const LatestBlogBlock = (props) => {	
    return(
	<>
	{/* <!-- LATEST BLOG SECTION START  --> */}
	<div>
		<div className="container">
			{/* <!-- TITLE --> */}
			<div className="section-head text-center">
				<h2><span className="site-text-primary">Latest </span> News</h2>
				<div className="wt-separator-outer ">
					<div className="wt-separator style-icon">
						<i className="fa fa-leaf text-black"></i>
						<span className="separator-left site-bg-primary"></span>
						<span className="separator-right site-bg-primary"></span>
					</div>                            
				</div>
				<p>Have a look at all the events and gatherings at {process.env.REACT_APP_SITE_TITLE}.</p>
			</div>
			
			{/* <!-- TITLE --> */}
			
			<div className="section-content ">
				<div className="row equal-wraper">
					
					 
					
					{/* <!-- COLUMNS 1 --> */}
					<div className="col-lg-6 col-md-12 m-b30">
					
						{blogs.map(blog => (
							<div className="blog-post latest-blog-3 blog-md date-style-1 clearfix" key={blog.id}>
								<div className="wt-post-media wt-img-effect zoom-slow">
									<Link to="/blog-single-sidebar"><img src={blog.imageThumbnail} alt="" /></Link>
								</div>
								<div className="wt-post-info" style={{overflow:'unset'}}>
									<div className="wt-post-title ">
										<h4 className="post-title font-weight-800"><Link to="/blog-single-sidebar">{blog.title}</Link></h4>
									</div>
									<div className="wt-post-meta ">
										<ul>
											<li className="post-date"> <i className="fa fa-calendar"></i><strong>{blog.createdDate.toDateString().toLocaleString()} </strong><span>{blog.createdDate.toLocaleTimeString()}</span></li>
											<li className="post-author"><i className="fa fa-user"></i><Link to="/blog-single-sidebar">By <span>{blog.createdBy}</span></Link></li>
											<li className="post-comment"><i className="fa fa-comments"></i> <Link to="/blog-single-sidebar">{blog.comments}</Link> </li>
										</ul>
									</div>
									<div className="wt-post-text">
										<p>{blog.description}</p> 
									</div>
									
								</div>
							</div>
						))}
					
					</div>
					<div className="col-lg-6 col-md-12">
						<div className="blog-post latest-blog-3 overlay-wraper post-overlay date-style-1 bg-cover bg-no-repeat bg-top-center" style={{backgroundImage:`url(${blogs.length > 0?blogs[0].imageLarge:''})`}}>
							<div className="overlay-main opacity-08 primary-gradi"></div>
							<div className="wt-post-info p-a30 text-white">
								<div className="post-overlay-position">
									<div className="wt-post-title ">
										<h3 className="post-title"><Link to="/blog-single-sidebar" className="text-white text-capitalize">{blogs.length > 0?blogs[0].title:''}</Link></h3>
									</div>
									<div className="wt-post-meta ">
										<ul>
											<li className="post-date"><i className="fa fa-calendar"></i><strong>{blogs.length > 0?blogs[0].createdDate.toDateString().toLocaleString():''}</strong> <span> {blogs[0].createdDate.toLocaleTimeString()}</span></li>
											<li className="post-author"><i className="fa fa-user"></i>By <Link to="/blog-single-sidebar">{blogs.length > 0?blogs[0].createdBy:''}</Link> </li>
											<li className="post-comment"><i className="fa fa-comments"></i> <Link to="/blog-single-sidebar">{blogs.length > 0?blogs[0].comments:''} comment</Link> </li>
										</ul>
									</div>
									<div className="wt-post-text">
										<p>{blogs.length > 0?blogs[0].description:''}</p> 
									</div>
								</div>
							</div>
						</div>
					</div>                            
				</div>
			</div>
		</div>
	</div>
	{/* <!-- LATEST BLOG SECTION END  --> */} 
    </>
    )
}
export default LatestBlogBlock;